// @ts-nocheck
import React from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Users, GitMerge } from "lucide-react";
import TeamsList from "@/components/teams/TeamsList";

/**
 * Org-scoped Teams page. The list itself is the shared TeamsList component
 * (identical UI/endpoint as the /club-dash "Your teams" list). Admins get the
 * My/All scope toggle automatically from the unified endpoint.
 */
const OrgTeamsPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold tracking-tight flex items-center gap-2">
            <Users className="w-6 h-6 text-primary" /> Teams
          </h1>
          <p className="text-sm text-muted-foreground mt-1">
            Your teams and the teams registered for your events.
          </p>
        </div>
        <Button variant="outline" onClick={() => navigate("/admin/teams/merge")}>
          <GitMerge className="w-4 h-4 mr-2" /> Merge Duplicates
        </Button>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Teams</CardTitle>
        </CardHeader>
        <CardContent>
          <TeamsList />
        </CardContent>
      </Card>
    </div>
  );
};

export default OrgTeamsPage;
